import { Box, Step, StepButton, StepLabel, Stepper } from '@mui/material';
import React, { useMemo } from 'react';

import { ICsvUploadStep } from '../../csvUploadProfile';

interface IProps {
  currentStep: number;
  visitedStep: number;
  onStepClick: (stepNum: number) => void;
  isNextStepDisabled: boolean;
  steps: ICsvUploadStep[];
}

const StepperNav: React.FC<IProps> = ({ currentStep, visitedStep, onStepClick, isNextStepDisabled, steps }) => {
  const stepButtons = useMemo(() => {
    return steps.map(({ num, label }, index) => {
      const isNextStep = num === currentStep + 1;
      const isVisited = num <= visitedStep;
      const canNavigate = num <= currentStep || (isNextStep && !isNextStepDisabled) || isVisited;
      const isDisabled = !canNavigate;

      const isActive = index === currentStep - 1 || isVisited;
      const isCompleted = index < currentStep - 1;

      return (
        <Step key={num} completed={isCompleted} active={isActive}>
          <StepButton
            disableRipple
            disabled={isDisabled}
            onClick={() => canNavigate && onStepClick(num)}
            data-action={`modal_step_button`}
            data-index={index}
          >
            <StepLabel>{label}</StepLabel>
          </StepButton>
        </Step>
      );
    });
  }, [steps, currentStep, visitedStep, onStepClick, isNextStepDisabled]);

  return (
    <Box>
      <Stepper
        activeStep={currentStep - 1}
        nonLinear
        sx={{
          my: 2,
          mx: 0,
          padding: 0,
        }}
        data-action="modal_stepper"
      >
        {stepButtons}
      </Stepper>
    </Box>
  );
};

export default StepperNav;
